import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/auth/`;

class AuthService {
  login(email, password) {
    return axios
      .post(API_URL + "signin", { email, password }) // 🔹 Ahora envía email en lugar de username
      .then(response => {
        console.log("Respuesta del backend:", response.data); // Debug
        if (response.data.token) {
          localStorage.setItem("user", JSON.stringify(response.data)); // Guardar usuario
        }
        return response.data;
      })
      .catch(error => {
        console.error("Error en login:", error.response ? error.response.data : error.message);
        throw error;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(username, email, password, role) {
    return axios.post(API_URL + "signup", { username, email, password, role });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }
}

const authService = new AuthService();
export default authService;